const initialState = {
    schedules: [],
    dates: [],
    offset: 0,
    id: 0,
    gender: "",
    cabinetName: [],
};

export default function AppointmentReducer(state=initialState, action) {
    switch (action.type) {
        case 'REQUEST_FAIL' : {
            return { data: action.payload };
        }
        case 'RESPONSE_LOAD_OK' : {
            return Object.assign({}, state, {
                schedules: action.schedules,
                dates: action.dates,
                offset: action.offset,
                id: action.id,
                gender: action.gender,
                cabinetName: action.cabinetName,
            })
        }
        case 'RESPONSE_PARSE_ERROR' : {
            return { data: action.payload };
        }
        default: return state;
    }
}



// WEBPACK FOOTER //
// frontend/src/reducers/AppointmentReducer.js